import(/* webpackMode: "eager" */ "/srv/panel/app/login/forgot-password/page.tsx");
